<!-- This example requires Tailwind CSS v2.0+ -->
<template>
    <RadioGroup v-model="selectedMailingLists">
        <div class="mt-4 grid grid-cols-1 gap-y-6 sm:grid-cols-3 sm:gap-x-4">
            <RadioGroupOption as="template" v-for="mailingList in mailingLists" :key="mailingList.id" :value="mailingList" v-slot="{ checked, active }">
                <div :class="[checked ? 'border-transparent' : 'border-gray-300', active ? 'border-indigo-500 ring-2 ring-indigo-500' : '', 'relative bg-white border rounded-lg shadow-sm p-4 flex cursor-pointer focus:outline-none']">
                    <div class="flex-1 flex">
                        <div class="flex flex-col">
                            <RadioGroupLabel as="span" class="block text-sm font-medium text-gray-900">
                                {{ mailingList.title }}
                            </RadioGroupLabel>
                            <RadioGroupDescription as="span" class="mt-1 flex items-center text-sm text-gray-500">
                                {{ mailingList.description }}
                            </RadioGroupDescription>
                        </div>
                    </div>
                    <CheckCircleIcon :class="[!checked ? 'invisible' : '', 'h-5 w-5 text-indigo-600']" aria-hidden="true" />
                    <div :class="[active ? 'border' : 'border-2', checked ? 'border-indigo-500' : 'border-transparent', 'absolute -inset-px rounded-lg pointer-events-none']" aria-hidden="true" />
                </div>
            </RadioGroupOption>
        </div>
    </RadioGroup>
</template>

<script>
import { ref } from 'vue'
import { RadioGroup, RadioGroupDescription, RadioGroupLabel, RadioGroupOption } from '@headlessui/vue'
import { CheckCircleIcon } from '@heroicons/vue/24/solid'

const mailingLists = [
    { id: 1, title: 'Динамический QR код', description: 'Можно изменить содержимое в любое время, даже после печати' },
    { id: 2, title: 'Обычный QR код', description: 'Нельзя изменить после создания и нельзя собирать аналитику' },
]

export default {
    components: {
        RadioGroup,
        RadioGroupDescription,
        RadioGroupLabel,
        RadioGroupOption,
        CheckCircleIcon,
    },
    setup() {
        const selectedMailingLists = ref(mailingLists[0])

        return {
            mailingLists,
            selectedMailingLists,
        }
    },
}
</script>
